export enum BoxShadow {
  BackgroundShadow = '0px 0px 4px rgba(0, 0, 0, 0.2);',
}
